import React, { useCallback, useContext, useMemo, useState } from "react";
import CustomSelect from "./CustomSelect";
import { BOTTOM_VIEW, SIZE_SELECT_DATA } from "../services/constant";
import ParamsContext from "../context/ParamsContext";
import { X } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
const ScanMeasurementCompo = ({ setBottomView }) => {
  const { scanData } = useContext(ParamsContext);
  const [selectValue, setSelectValue] = useState(SIZE_SELECT_DATA[0].value);
  const selectedData = useMemo(
    () => scanData?.[selectValue],
    [selectValue, scanData]
  );

  const handleSelectChange = useCallback((data) => {
    setSelectValue(data);
  }, []);
  const { theme } = useTheme();
  return (
    <>
{   setBottomView &&    <button
        className={`absolute top-2 right-2 p-1.5 rounded-full transition-colors duration-200 w-[28px] h-[28px] flex items-center justify-center ${
          theme === "light"
            ? "bg-gray-100 text-gray-500 hover:text-gray-900 hover:bg-gray-200"
            : "bg-gray-800 text-gray-400 hover:text-gray-100 hover:bg-gray-700"
        }`}
        onClick={() => setBottomView(BOTTOM_VIEW.NONE)}
      >
        <X className="w-[100%] block" />
      </button>}

      <div className={`${!setBottomView && `pl-[60px] pb-[30px]` } h-full overflow-y-auto pr-4  [&::-webkit-scrollbar]:w-1
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:bg-gray-300
  dark:[&::-webkit-scrollbar-track]:bg-neutral-700
  dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500`}>
        <p className="text-[16px] font-medium pr-[30px] mb-1">Suggested Size</p>

        <div className="flex items-center mb-[10px]">
          <div
            className={`text-[14px] mr-2 ${
              theme === "light" ? "text-gray-600" : "text-gray-300"
            }`}
          >
            Fit Preference
          </div>
          <CustomSelect
            onChange={handleSelectChange}
            data={SIZE_SELECT_DATA}
            value={selectValue}
          />
        </div>

        <div className="text-3xl font-medium mb-1">{selectedData?.size}</div>
        {selectedData?.fit_notes && (
          <p className="text-[14px]">{selectedData?.fit_notes}</p>
        )}
        {selectedData?.description && (
          <p className="text-[14px] text-gray-600 mt-3">
            {selectedData?.description}
          </p>
        )}
      </div>
    </>
  );
};

export default ScanMeasurementCompo;
